import { useQuery } from '@apollo/client/react';

import { useAuth } from '@/auth/useAuth';

import { ME, type Person } from './arcade-api';

export interface PersonState {
  person: Person | null;
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

/** The signed-in identity's Arcade Person; null until they create one. */
export function usePerson(): PersonState {
  const { status } = useAuth();
  const { data, loading, error, refetch } = useQuery(ME, { skip: status !== 'authenticated' });
  return {
    person: data?.me ?? null,
    loading: status === 'authenticated' && loading && !data,
    error,
    refetch: () => void refetch(),
  };
}
